import { Select, SelectOption } from 'ui';
import useQueryApiClient from 'utils/useQueryApiClient';
import { Validations } from 'interfaces';
import { FormItemLayout } from 'antd/es/form/Form';
import { useIntl } from 'react-intl';
import { useEffect } from 'react';

interface EnumProps {
  id: number;
  name: string;
}

interface CartSelectProps extends Validations {
  name?: (string | number)[] | string | number;
  mode?: 'multiple' | 'tags';
  noStyle?: boolean;
  label?: string;
  disabled?: boolean;
  layout?: FormItemLayout;
  onChange?: (v: string) => void;
  initialValue?: string | number;
  reload?: number;
  showNew?: boolean;
}

const CartSelect = ({
  name,
  mode,
  validations,
  noStyle,
  label,
  disabled,
  layout,
  onChange,
  initialValue,
  reload,
  showNew,
}: CartSelectProps) => {
  const intl = useIntl();

  const { data, appendData } = useQueryApiClient({
    request: {
      url: `api/v2/cart/select`,
      disableOnMount: true,
    },
  });

  useEffect(() => {
    appendData();
  }, [reload]);

  if (!data?.length && !showNew) {
    return <></>;
  }

  return (
    <Select
      mode={mode}
      label={label}
      name={name}
      validations={validations}
      noStyle={noStyle}
      disabled={disabled}
      layout={layout}
      onChange={onChange}
      defaultValue={initialValue}
      placeholder={intl.formatMessage({ id: 'cart.cart_placeholder' })}
    >
      {data.map((entry: EnumProps) => (
        <SelectOption key={entry.id} value={entry.id}>
          {entry.name}
        </SelectOption>
      ))}
      {showNew && (
        <SelectOption key={'NEW'} value={'NEW'}>
          <b>{intl.formatMessage({ id: 'cart.new_cart' })}</b>
        </SelectOption>
      )}
    </Select>
  );
};

export default CartSelect;
